import { useEffect, useState } from "react";
import OTPInput from "react-otp-input";
import Button from "../../shared/Button";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { useMutation } from "react-query";
import { sendUserOtp, verifyUserOtp } from "../../sdk/auth/auth";
import { useError } from "../../context/ErrorProvider";
import { hasPermission } from "../../utils/permissions";

const OneTimePassword = () => {
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();
  const { auth, setAuth } = useAuth();
  const [secondsLeft, setSecondsLeft] = useState(30);
  const { showError } = useError();

  const { mutate: sendOtpMutate } = useMutation({
    mutationKey: "send-otp",
    mutationFn: (userId) => sendUserOtp(userId),
    onSuccess: () => {
      setSecondsLeft(30);
    },
    onError: (error) => {
      showError(error?.response?.data?.message || error.message);
    },
  });

  const handleResendOtp = () => {
    setOtp("");
    sendOtpMutate(auth?.user?.id);
  };

  const { mutate: verifyOtpMutate, isLoading: isLoadingverifyOtp } =
    useMutation({
      mutationKey: "verify-otp",
      mutationFn: ({ otp, email, userId }) => verifyUserOtp(otp, email, userId),
      onSuccess: (data) => {
        setAuth({
          user: data.data.user,
          tokens: data.data.tokens,
          roles: data?.data?.userPermissions,
        });
        if (auth?.user?.logintimes > 0) {
          if (
            hasPermission(
              data?.data?.data?.userPermissions,
              "9cf6c30f-4f90-7a12-19cc-52fcd5bb7c37",
            )
          ) {
            navigate("/dashboard");
          } else {
            navigate("/dashboard/loans-applications");
          }
        } else {
          navigate("/set-new-password");
        }
      },
      onError: (error) => {
        showError(error?.response?.data?.message || error.message);
      },
    });

  useEffect(() => {
    if (secondsLeft === 0) return;

    const timer = setInterval(() => {
      setSecondsLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [secondsLeft]);

  const verifyPassword = (e) => {
    e.preventDefault();
    if (otp.length !== 6) {
      showError("Your otp is invalid");
    }
    verifyOtpMutate({ otp, email: auth?.user?.email, userId: auth?.user?.id });
  };

  const maskedMobile =
    auth?.user?.phone?.length >= 10
      ? `${auth.user.phone.slice(0, 3)}******${auth.user.phone.slice(-2)}`
      : auth?.user?.phone;

  return (
    <div className="w-full h-full flex flex-col pb-[100px] justify-end">
      <p className="text-[#222222] text-[20px] font-semibold">
        Additional security verification
      </p>
      <form className="w-[80%]" onSubmit={verifyPassword}>
        <p className="text-[14px] text-[#5C5C5C] mt-[10px] mb-[30px] font-normal">
          For added security we need to further verify your account we just sent
          an SMS to the phone number{" "}
          <span className="text-[#000000]">{maskedMobile}</span>
        </p>
        <div className="flex flex-col my-[20px] gap-[5px]">
          <p className="text-[#000000] text-[14px] font-medium">
            One time password
          </p>
          <OTPInput
            value={otp}
            onChange={setOtp}
            numInputs={6}
            shouldAutoFocus
            renderInput={(props) => (
              <input
                {...props}
                style={{
                  width: "50px",
                  height: "50px",
                  border: "2px solid #5C5C5C",
                }}
              />
            )}
            renderSeparator={<span className="mx-2" />}
            inputStyle="bg-white text-center text-[24px] rounded-[5px] text-[#000] border-[1px] border-[#000]"
          />
        </div>
        <div className="flex items-center justify-between my-[50px]">
          {secondsLeft === 0 ? (
            <p
              onClick={handleResendOtp}
              className="text-[#000000] underline text-[16px] font-normal cursor-pointer"
            >
              Resend OTP
            </p>
          ) : (
            <p className="text-[#5C5C5C] text-[16px] font-normal">
              Enter or paste the one time password
            </p>
          )}
          <p className="text-[#000000] font-semibold text-[15px]">
            00:{secondsLeft < 10 ? `0${secondsLeft}` : secondsLeft}
          </p>
        </div>
        <div className="my-[20px] w-full">
          <Button
            label="Verify"
            isLoading={isLoadingverifyOtp}
            disabled={isLoadingverifyOtp}
          />
        </div>
      </form>
    </div>
  );
};

export default OneTimePassword;
